/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 1:38 PM
 *
 */

import React from 'react';
import clsx from 'clsx';

import ErrorImage from 'assets/img/not-found.svg';

interface IErrorStateProps {
  title: string;
  subtitle?: string;
  image?: string;
  height?: `h-${string}`;
  containerClassName?: string;
}

/**
 *
 * @param {string} title
 * @param {string} subtitle
 * @param {string}image
 * @param {string} height - Tailwind height class
 * @param {string} containerClassName
 * @return {JSX.Element}
 */
function ErrorState({ title, subtitle, image, height, containerClassName }: IErrorStateProps) {
  return (
    <div
      className={clsx({
        'flex flex-col items-center justify-start gap-4 py-32': !containerClassName,
        containerClassName: !!containerClassName,
      })}
    >
      <img
        src={image ?? ErrorImage}
        alt="Empty State"
        className={clsx('relative w-full object-contain', {
          'h-32': !height,
          height: !!height,
        })}
      />

      <div className="flex flex-col items-center">
        <div className="text-3xl font-medium text-primary-600">{title}</div>
        <div className="text-lg font-medium text-gray-500">{subtitle}</div>
      </div>
    </div>
  );
}

export default ErrorState;
